import React from "react";

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=629-14965&t=3lunUvpzgaQBTI5S-4
type Direction = "right" | "left" | "top" | "bottom";
type Size = "large" | "small";

type ToolTipProps = {
  label: string | React.ReactNode;
  selected: boolean;
  size: Size; //large, small
  onClick?: () => void;
  direction?: Direction;
  widthPosition?: number;
  style?: React.CSSProperties;
  otherClassName?: string;
};

const ToolTipArrow = (props: any): React.JSX.Element => {
  const { direction, size, widthPosition = 50 } = props;

  const arrowContainerStyle = {
    position: "absolute" as const,
    ...(direction === "top" && { top: "-8px" }),
    ...(direction === "bottom" && { bottom: "-8px" }),
    ...(direction === "left" && { left: "-8px", top: "12px" }),
    ...(direction === "right" && { right: "-8px" }),
    ...(["top", "bottom"].includes(direction) && {
      left: `${widthPosition}%`,
      transform: "translateX(-50%)",
    }),
  };

  const renderArrow = () => {
    if (direction == "right") {
      if (size == "large") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
          >
            <path
              d="M6.93333 5.2C7.46667 5.6 7.46667 6.4 6.93333 6.8L5.24537e-07 12L0 3.49691e-07L6.93333 5.2Z"
              fill="white"
            />
          </svg>
        );
      } else {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
          >
            <path
              d="M5.07813 4.23178C5.55789 4.63157 5.55789 5.36842 5.07813 5.76822L-4.37114e-07 10L0 -2.62268e-07L5.07813 4.23178Z"
              fill="white"
            />
          </svg>
        );
      }
    } else if (direction == "left") {
      if (size == "large") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
          >
            <path
              d="M1.06667 5.2C0.533333 5.6 0.533333 6.4 1.06667 6.8L8 12L8 3.49691e-07L1.06667 5.2Z"
              fill="white"
            />
          </svg>
        );
      } else {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
          >
            <path
              d="M0.921867 4.23178C0.442112 4.63157 0.442112 5.36842 0.921866 5.76822L6 10L6 -2.62268e-07L0.921867 4.23178Z"
              fill="white"
            />
          </svg>
        );
      }
    } else if (direction == "top") {
      if (size == "large") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
          >
            <path
              d="M6.8 1.06667C6.4 0.533334 5.6 0.533334 5.2 1.06667L6.99382e-07 8L12 8L6.8 1.06667Z"
              fill="white"
            />
          </svg>
        );
      } else {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="6"
            viewBox="0 0 11 6"
            fill="none"
          >
            <path
              d="M6.26822 0.921867C5.86843 0.442113 5.13158 0.442112 4.73178 0.921866L0.500001 6L10.5 6L6.26822 0.921867Z"
              fill="white"
            />
          </svg>
        );
      }
    } else if (direction == "bottom") {
      if (size == "large") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
          >
            <path
              d="M6.8 6.93333C6.4 7.46667 5.6 7.46667 5.2 6.93333L6.99382e-07 -1.04907e-06L12 0L6.8 6.93333Z"
              fill="white"
            />
          </svg>
        );
      } else {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="6"
            viewBox="0 0 11 6"
            fill="none"
          >
            <path
              d="M6.26822 5.07813C5.86843 5.55789 5.13158 5.55789 4.73178 5.07813L0.500001 -8.74228e-07L10.5 0L6.26822 5.07813Z"
              fill="white"
            />
          </svg>
        );
      }
    } else {
      return null;
    }
  };

  return <div style={arrowContainerStyle}>{renderArrow()}</div>;
};

const ToolTip = (props: ToolTipProps) => {
  const { label, selected, size, onClick, direction, widthPosition, style, otherClassName } = props;

  if (!selected) return null;

  return (
    <div
      className={`tooltip ${direction} ${size}`}
      onClick={onClick}
      style={{
        ...style,
        position: "relative",
        cursor: onClick ? "pointer" : "default",
        ...(direction === "left" && {
          marginLeft: size === "large" ? "8px" : "6px"
        })
      }}
    >
      <div
        className={`tooltip-label ${size} ${otherClassName || ""}`}
        style={{
          whiteSpace: "nowrap",
          position: "relative",
          cursor: onClick ? "pointer" : "default",
        }}
      >
        {label}
        <ToolTipArrow direction={direction} size={size} widthPosition={widthPosition} />
      </div>
    </div>
  );
};

export { ToolTip };
